export const ITEMS_PER_PAGE = 10;

export const SOURCE_TYPES = {
  PROVIDER: 'provider',
  WAREHOUSE: 'warehouse',
};

export const SOURCE_TYPE_LABELS = {
  provider: 'Proveedor',
  warehouse: 'Depósito',
};

export const SUPPLY_ORDER_STATUSES = {
  DRAFT: 'draft',
  ISSUED: 'issued',
  SENT: 'sent',
  ACKNOWLEDGED: 'acknowledged',
  PARTIALLY_RECEIVED: 'partially_received',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
};

export const SUPPLY_ORDER_STATUS_LABELS = {
  draft: 'Borrador',
  issued: 'Emitida',
  sent: 'Enviada',
  acknowledged: 'Confirmada',
  partially_received: 'Parcialmente recibida',
  received: 'Recibida',
  cancelled: 'Cancelada',
  closed: 'Cerrada',
};

export const SUPPLY_ORDER_STATUS_COLORS = {
  draft: 'default',
  issued: 'info',
  sent: 'primary',
  acknowledged: 'secondary',
  partially_received: 'warning',
  received: 'success',
  cancelled: 'error',
  closed: 'default',
};

export const TERMINAL_STATUSES = [
  SUPPLY_ORDER_STATUSES.RECEIVED,
  SUPPLY_ORDER_STATUSES.CANCELLED,
  SUPPLY_ORDER_STATUSES.CLOSED,
];

export const EDITABLE_STATUSES = [SUPPLY_ORDER_STATUSES.DRAFT];

export const RECEIVABLE_STATUSES = [
  SUPPLY_ORDER_STATUSES.ISSUED,
  SUPPLY_ORDER_STATUSES.SENT,
  SUPPLY_ORDER_STATUSES.ACKNOWLEDGED,
  SUPPLY_ORDER_STATUSES.PARTIALLY_RECEIVED,
];

export const PRINTABLE_STATUSES = [
  SUPPLY_ORDER_STATUSES.ISSUED,
  SUPPLY_ORDER_STATUSES.SENT,
  SUPPLY_ORDER_STATUSES.ACKNOWLEDGED,
  SUPPLY_ORDER_STATUSES.PARTIALLY_RECEIVED,
  SUPPLY_ORDER_STATUSES.RECEIVED,
  SUPPLY_ORDER_STATUSES.CLOSED,
];

export const INITIAL_SUPPLY_ORDER_STATE = {
  source_type: SOURCE_TYPES.PROVIDER,
  uuid_provider_legal_entity: '',
  uuid_source_warehouse: '',
  uuid_destination_warehouse: '',
  required_at: '',
  provider_delivery_commitment_at: '',
  delivery_place: '',
  delivery_contact_name: '',
  delivery_contact_phone: '',
  conditions: '',
  observations: '',
  materials: [],
};

export const getInitialSupplyOrderState = () => ({
  ...INITIAL_SUPPLY_ORDER_STATE,
  materials: [],
});

export const INITIAL_FILTERS = {
  query: '',
  status: '',
  source_type: SOURCE_TYPES.PROVIDER,
  uuid_provider_legal_entity: '',
  uuid_destination_warehouse: '',
  date_from: '',
  date_to: '',
};
